import { observer } from 'mobx-react-lite';
import DateTypeField from '../FieldByType/dateTypeField';
import TextStringTypeField from '../FieldByType/textStringTypeField';
import UrlTypeField from '../FieldByType/urlTypeField';
import SwitchVariantTypeField from '../FieldByType/switchVariantTypeField';
import ColorTypeField from '../FieldByType/colorTypeField';
import SwitchTypeField from '../FieldByType/switchTypeField';
import SampleTypeField from '../FieldByType/sampleTypeField';
import StatusTypeField from '../FieldByType/statusTypeField';
import LinkTypeField from '../FieldByType/linkTypeField';
import IsActiveTypeField from '../FieldByType/isActiveTypeField';
import SelectToPrintTypeField from '../FieldByType/selectToPrintTypeField';
import IntegerTypeField from '../FieldByType/integerTypeField';
import PropTypes from 'prop-types';
import ImageTypeField from '../FieldByType/imageTypeField';

const TableFieldRenderer = observer(({ type, forTable, ...commonProps }) => {
  switch (type) {
    case 'integer':
    case 'numeric':
    case 'range':
    case 'float':
      return <IntegerTypeField forTable={forTable} {...commonProps} />;
    case 'string':
    case 'text':
    case 'email':
    case 'phone':
    case 'base':
    case 'select':
    case 'date':
    case 'location':
    case 'calc':
    case 'time':
    case 'period':
      return <TextStringTypeField forTable={forTable} {...commonProps} />;
    case 'Дата':
      return <DateTypeField forTable={forTable} {...commonProps} />;
    case 'switch':
      return <SwitchTypeField forTable={forTable} {...commonProps} />;
    case 'url':
      return <UrlTypeField forTable={forTable} {...commonProps} />;
    case 'sample':
      return <SampleTypeField forTable={forTable} {...commonProps} />;
    case 'status':
      return <StatusTypeField forTable={forTable} {...commonProps} />;
    case 'color':
      return <ColorTypeField forTable={forTable} {...commonProps} />;
    case 'link':
      return <LinkTypeField forTable={forTable} {...commonProps} />;
    case 'is_active':
      return <IsActiveTypeField forTable={forTable} {...commonProps} />;
    case 'selectToPrint':
      return <SelectToPrintTypeField forTable={forTable} {...commonProps} />;
    case 'switch_variants':
      return <SwitchVariantTypeField forTable={forTable} {...commonProps} />;
      case 'image':
      return <ImageTypeField forTable={forTable} {...commonProps} />;
    default:
      return null;
  }
});

TableFieldRenderer.propTypes = {
  type: PropTypes.string.isRequired,
  forTable: PropTypes.bool,
};

export default TableFieldRenderer;
